define([
  "marionette",
  "backbone",
  "messaging/messenger",
  "modules/admin/userAdministration/userDetails/kbSelectDisplay/kbSelectView",
], function (Marionette, Backbone, Messenger, KbSelectView) {
  "use strict";

  return Marionette.Controller.extend({
    initialize: function (options) {
      this.region = options.region;
      this.name = "kbSelectModule";
    },
    show: function (kbs) {
      this.kbs = kbs;
      this.view = new KbSelectView.kbSelectView({ collection: kbs });

      this.view.on(
        "kb:changed",
        function (kbId) {
          let kb = this.kbs.findWhere({ kbId: kbId });
          const taskManagement = kb.get("taskManagement");
          const adHocReporting = kb.get("adHocReporting");
          const recommendations = kb.get("recommendations");
          Messenger.vent.trigger(
            "change:selected:kb",
            kbId,
            taskManagement,
            adHocReporting,
            recommendations,
          );
        },
        this,
      );

      this.view.on(
        "show",
        function () {
          this._showSubViews();
        },
        this,
      );
      this.showRegion(this.view);
      if (this.kbs.size() > 0) {
        const kb = kbs.at(0);
        Messenger.vent.trigger(
          "change:selected:kb",
          kb.get("kbId"),
          kb.get("taskManagement"),
          kb.get("adHocReporting"),
          kb.get("recommendations"),
        );
      }
    },
    _showSubViews: function () {},
  });
});
